<template>
  <HighlightContainerCheckout
    title=" Queremos saber um pouco mais de você!"
    subtitle="Preencha seus dados e conheça nossas condições de pagamento."
    even
    class="pa-0"
  >
    <v-form ref="leadForm" v-model="validLeadForm">
      <v-row>
        <template v-if="leadContactEnableRever === false">
          <v-col class="col-12 col-md-5">
            <label for="chkt-nome" class="v-label">Nome completo *</label>
            <v-text-field
              id="chkt-nome"
              v-model="leadForm.lead_contact_name"
              :rules="leadFormRules.lead_contact_name_rules"
              required
              placeholder="Informe seu nome completo"
              color="#26d07c"
              solo
            />
          </v-col>
          <v-col class="col-12 col-md-5 offset-md-1">
            <label for="chkt-email" class="v-label">E-mail *</label>
            <v-text-field
              id="chkt-email"
              v-model="leadForm.lead_contact_email"
              :rules="leadFormRules.lead_contact_email_rules"
              required
              validate-on-blur
              label="E-mail"
              placeholder="email@exemplo.com"
              color="#26d07c"
              solo
              type="email"
            />
          </v-col>
          <v-col class="col-12 col-md-5">
            <label for="chkt-celular" class="v-label">Celular *</label>
            <v-text-field
              id="chkt-celular"
              v-model="leadForm.lead_contact_mobile_phone"
              v-mask="'(##) #####-####'"
              :rules="leadFormRules.lead_contact_mobile_phone_rules"
              validate-on-blur
              placeholder="(00) 12345-6789"
              color="#26d07c"
              solo
              type="tel"
            />
          </v-col>
          <v-col class="col-12 col-md-5 offset-md-1">
            <label for="chkt-empresa" class="v-label">Empresa *</label>
            <v-text-field
              id="chkt-empresa"
              v-model="leadForm.lead_contact_company_name"
              :rules="leadFormRules.lead_contact_company_name_rules"
              required
              placeholder="Informe o nome da empresa"
              color="#26d07c"
              solo
            />
          </v-col>
          <v-col class="col-12 col-md-5 py-0">
            <v-checkbox
              v-model="leadForm.lead_contact_enable_whatsapp"
              class="ma-0"
              label="Desejo receber informações via WhatsApp"
              required
              color="#26d07c"
              solo
            />
          </v-col>
          <v-col class="col-12 col-md-5 offset-md-1 py-0">
            <v-checkbox
              v-model="leadForm.lead_contact_fiesp_associate"
              class="ma-0"
              label="Sou associado a entidade gestora GIRO"
              color="#26d07c"
              solo
            />
          </v-col>
          <v-col class="col-12 col-md-5">
            <label for="chkt-uf" class="v-label"
              >Estado da matriz da empresa *</label
            >
            <v-autocomplete
              id="chkt-uf"
              v-model="leadForm.lead_contact_state"
              :rules="leadFormRules.lead_contact_state_rules"
              :items="states"
              item-text="nome"
              item-value="sigla"
              no-data-text="Selecione uma das opções"
              auto-select-first
              hide-details="true"
              color="#26d07c"
              required
              solo
              @change="getCitiesByState"
            ></v-autocomplete>
          </v-col>
          <v-col class="col-12 col-md-5 offset-md-1">
            <label for="chkt-referencia" class="v-label"
              >Cidade da matriz da empresa *</label
            >
            <v-autocomplete
              id="chkt-referencia"
              v-model="leadForm.lead_contact_city"
              :rules="leadFormRules.lead_contact_city_rules"
              :items="cities"
              item-text="nome"
              item-value="nome"
              no-data-text="Selecione um estado"
              auto-select-first
              hide-details="true"
              color="#26d07c"
              required
              solo
            ></v-autocomplete>
          </v-col>
          <v-col class="col-12 useterms">
            <v-checkbox
              v-model="leadForm.lead_contact_terms"
              :rules="leadFormRules.lead_contact_terms_rules"
              :input-value="termUse"
              class="py-0 my-0 pb-2"
              @change="setTermUse"
            >
              <template v-slot:label>
                <div>
                  Eu aceito os
                  <v-dialog
                    v-model="modalTermUse"
                    :fullscreen="$vuetify.breakpoint.mobile && true"
                    :persistent="$vuetify.breakpoint.mobile && true"
                    scrollable
                  >
                    <template v-slot:activator="{ on }">
                      <a v-on="on" @click.stop> Termos de Uso </a>
                    </template>
                    <v-card>
                      <v-toolbar>
                        <v-btn
                          icon
                          dark
                          style="
                            background-color: transparent !important;
                            color: #000 !important;
                          "
                          @click="modalTermUse = false"
                        >
                          <v-img
                            :src="
                              require('@/assets/images/materialicons/close-gray.svg')
                            "
                            contain
                            max-width="24"
                          />
                        </v-btn>
                        <v-toolbar-title
                          >TERMOS E CONDIÇÕES GERAIS DE USO DA PLATAFORMA
                          EURECICLO</v-toolbar-title
                        >
                      </v-toolbar>
                      <v-card-text class="pa-3">
                        <UseTerms />
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  e a
                  <a href="/politica-de-privacidade" target="_blank" @click.stop
                    >Política de Privacidade</a
                  >
                  *
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </template>
      </v-row>
    </v-form>
  </HighlightContainerCheckout>
</template>

<script>
import CheckoutProvider from '@/providers/CheckoutProvider';
import { mask } from 'vue-the-mask';

export default {
  name: 'Step1',
  components: {
    HighlightContainerCheckout: () =>
      import('@/components/HighlightContainerCheckout.vue'),
    UseTerms: () => import('@/components/Checkout/UseTerms.vue'),
  },
  directives: { mask },
  props: {
    termUse: {
      type: Boolean,
      required: true,
    },
    modalTermUse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      validLeadForm: false,
      leadForm: {
        lead_contact_name: '',
        lead_contact_email: '',
        lead_contact_company_name: '',
        lead_contact_state: '',
        lead_contact_city: '',
        lead_contact_mobile_phone: '',
        lead_contact_enable_whatsapp: false,
        lead_contact_fiesp_associate: false,
        lead_contact_terms: false,
      },
      leadFormRules: {
        lead_contact_name_rules: [
          v => !!v || 'Nome é um campo obrigatório',
          v =>
            (v && v.length >= 3) || 'Nome deve conter no mínimo 3 caracteres',
          v =>
            (v && v.length <= 255) ||
            'Nome deve conter no máximo 255 caracteres',
        ],
        lead_contact_email_rules: [
          v => !!v || 'E-mail é um campo obrigatório',
          v =>
            /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(v) ||
            'Insira um e-mail válido',
        ],
        lead_contact_company_name_rules: [
          v => !!v || 'Nome da empesa é um campo obrigatório',
        ],
        lead_contact_state_rules: [
          v => !!v || 'Selecione uma das opções',
          v => (v && v.id !== 0) || 'Selecione uma opção válida',
        ],
        lead_contact_city_rules: [
          v => !!v || 'Selecione uma das opções',
          v => (v && v.id !== 0) || 'Selecione uma opção válida',
        ],
        lead_contact_mobile_phone_rules: [
          v => !!v || 'Celular é um campo obrigatório',
          v =>
            (v && v.length >= 15) ||
            'Celular deve conter 11 números contendo DDD',
        ],
        lead_contact_terms_rules: [v => !!v || 'Termos é um campo obrigatório'],
      },
      leadContactEnableRever: false,
      showInfoContent: false,
      states: [],
      cities: [],
    };
  },
  watch: {
    validLeadForm() {
      if (this.leadContactEnableRever === false) {
        this.$store.commit('validateStep1', this.validLeadForm);
        this.$store.commit('leadForm', this.leadForm);
      }
    },
    leadContactEnableRever() {
      this.validLeadForm = false;
      this.$store.commit('validateStep1', false);
    },
  },
  beforeMount() {
    this.getStates();
  },
  methods: {
    openInfoPopup() {
      this.showInfoContent = true;
    },
    closeInfoPopup() {
      this.showInfoContent = false;
    },
    async getStates() {
      try {
        this.$store.commit('setIsLoading', true);
        this.states = [
          ...(await CheckoutProvider.states().then(res => {
            return res.data;
          })),
        ];
        this.$store.commit('setIsLoading', false);
      } catch (err) {
        console.error(err);
      }
    },
    async getCitiesByState(uf) {
      try {
        this.$store.commit('setIsLoading', true);
        this.cities = await CheckoutProvider.citiesByState(uf).then(res => {
          return res.data;
        });
        this.$store.commit('setIsLoading', false);
      } catch (err) {
        console.error(err);
      }
    },
    setTermUse() {
      this.$emit('setTermUse', true);
    },
  },
};
</script>

<style lang="sass" scoped>
.enable-rever-wrapper
  position: relative
  display: flex
  align-items: center
  .info-icon
    position: relative
    display: block
    min-height: 40px
    color: #ef3e44
    font-size: 14px
    line-height: 1
    margin-left: 20px
    padding-top: 4px
    cursor: pointer
  .close-icon
    position: absolute
    top: 0
    right: 10px
    font-weight: 700
    cursor: pointer
  p
    position: absolute
    top: 0
    right: 12px
    background-color: rgb(255, 255, 255)
    max-width: 320px
    font-size: 1em
    font-weight: 400
    border: 1px solid #ef3e44
    padding: 13px
    transition-duration: 200ms
    transition-timing-function: ease
    transition-delay: 0s
    transition-property: all
    z-index: 1
  @media screen and (max-width: 767px)
    p
      top: 100%
      left: 12px
      max-width: calc(100% - 24px)
.new-color
  .enable-rever-wrapper
    p
      font-family: 'metropolisregular', sans-serif !important

.wrapper
  ::v-deep
    .title
      text-align: left !important
      font-size: 2rem !important
      font-weight: 600 !important
    .title + .row
      justify-content: flex-start !important
      .separator
        width: 50%
        height: 4px
        margin-top: 10px
        @media screen and (max-width: 959px)
          width: 80%
          height: 2px
</style>
